import { render } from "./QuestionnaireChoice.vue?vue&type=template&id=10dad6d0&scoped=true"
import script from "./QuestionnaireChoice.vue?vue&type=script&lang=js"
export * from "./QuestionnaireChoice.vue?vue&type=script&lang=js"

import "./QuestionnaireChoice.vue?vue&type=style&index=0&id=10dad6d0&lang=scss&scoped=true"
import "./QuestionnaireChoice.vue?vue&type=style&index=1&id=10dad6d0&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dad6d0"]])

export default __exports__